<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
<path d="M14.1667 9H5.83333C5.3725 9 5 9.448 5 10C5 10.552 5.3725 11 5.83333 11H14.1667C14.6275 11 15 10.552 15 10C15 9.448 14.6275 9 14.1667 9" fill="#5C5F62"/>
</svg>
